<template>
	<div class="votelist">
        <div v-if="familyList.length==0" class="votelist_notice">
            <van-image width="60%" height="60%" :src="require('@/assets/img/common/default.png')" @click="gotouch(item)"/>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
        >
            <div  v-for="(item,key) in familyList" :key="key"  class="item_votelist_parent">
        		  <div class="item_votelist" @click="canvass(item)">
                  <div class="votelist_videos">
                      <van-image width="2.92rem" height="2.17rem" :src="item.mediaurl" @click="gotouch(item)"/>
                  <div class="votelist_canvassing">
                    拉票
                  </div>
                  </div>
                  <div class="votelist_title">
                      <!-- <div class="votelist_id">NO.{{item.id}}</div> -->
                      <div class="votelist_cont">
                        <div class="votelist_name">{{item.name}}</div>
                        <div class="votelist_votes">{{item.score}} 票</div>
                      </div>
                  </div>
                  <div class="votelist_footer">
                    <div v-if="item.isvote" class="mvbutton vote">
                      已投
                    </div>
                    <div v-else class="mvbutton vote" @click.stop="go(item)">
                      我要投票
                    </div>
                  </div>
              </div>
            </div>
        </van-list>
	</div>
</template>
<script>
    import './index.less'
    import { Image, List} from 'vant';
    export default {
        name:"VoteList",
        data() {
            return {
                mediaurl: '',
                imgurl:'',
                familyList:[],
                loading: false,
                finished: false,
                page:1
            }
        },
        components: {
            vanImage:Image,
            vanList:List
        },
        props: {
            keyword: {
              type: String,
              default: ''
            },
          itemid: {
            type: String,
            default: ''
          },
          sportsid: {
            type: String,
            default: ''
          }
        },
        watch: {
            keyword: function (val) {
              this.keyword = val
              this.familyList = []
              this.page = 1
              this.finished   =   false
              // this.getFamilyList()
            }
        },
        methods: {
            go:function (row) {
                // console.log(val)
              this.$api.sports
                  .vote({
                    mcloud_sports_item_user_id: row.id,
                  })
                  .then((r) => {
                    this.familyList = []
                    this.page = 1
                    this.finished   =   false
                    // this.getFamilyList();
                  })
            },
            gotouch(item) {
                // this.$emit('goVideo',item);
                // var myVideo=document.getElementById("video");
                // myVideo.play();
                // if (myVideo.paused)
                //   myVideo.play();
                // else
                //   myVideo.pause();
            },
            canvass(item){
              this.$router.push({
                name: 'vote',
                params: {item_sub_id:this.itemid,sports_id:this.sportsid},
                query: { id: item.id },
              })
            },
            getFamilyList(){
                this.$api.sports.compareRank({page:this.page,keyword:this.keyword,cpgid: this.itemid}).then((res)=>{
                    if(res.status*1===200){
                        let list = res.data.list;
                        let myinfo = res.data.myinfo
                        list.forEach((item, index) => {
                          item.isvote = false
                          // if (item.urid == myinfo.myvote) {
                          item.score = Math.floor(item.score)
                          for(var i in myinfo.myvote){
                            if(myinfo.myvote[i] == item.urid){
                              item.isvote = true
                              return
                            }
                          }
                        })
                        this.familyList = this.familyList.concat(list)
                        if(res.data.pages*1>this.page){
                            this.page++
                        }else{
                            this.finished   =   true
                        }

                    }
                    this.loading = false;
                })
            },
            onLoad() {
                if(this.finished) return;
                this.getFamilyList();
            }
        },
        mounted(){
            this.$nextTick(()=>{
                // this.getFamilyList();
            })
        }
    }
</script>
